import { render, staticRenderFns } from "./Simulated.vue?vue&type=template&id=5f7cbf61&scoped=true"
import script from "./Simulated.vue?vue&type=script&lang=js"
export * from "./Simulated.vue?vue&type=script&lang=js"
import style0 from "../styles/Simulated.css?vue&type=style&index=0&id=5f7cbf61&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7cbf61",
  null
  
)

export default component.exports